import React, {useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState} from 'react';
import 'devextreme-react/text-area';
import {CheckBox} from 'devextreme-react/check-box';
import {Column, DataGridRef} from 'devextreme-react/data-grid';
import TabPanel, {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {FormRef, GroupItem, Label, SimpleItem, Tab, TabbedItem} from "devextreme-react/form";
import useCustomDataSource, {IFormBaseDataSourceOptions, Mode} from "../../hooks/useCustomDataSource";
import "./gestion-reservations.css"
import {FormListBase, FormListBaseGrid, FormListBaseToolbar} from '../base';
import useReservationCouleur from "../../components/selectbox/ReservationCouleur";
import useClient from "../../components/selectbox/client";
import {format} from "date-fns";
import formatTelephone from "../../utils/format-telephone";
import useLookUpBase from "../../components/selectbox/LookupBase";
import ListUniteDisponible from "./list-unite-disponible";
import IReservationList from "../../models/IReservationList";
import Guid from "../../models/Guid";
import IGestionReservation from "../../models/IGestionReservation";
import FormSysteme from "../../components/forms/form-systeme";
import IReservationEntete from "../../models/IReservationEntete";
import GestionReservaitonTrancheAgePopup from "./gestion-reservaiton-tranche-age-popup";
import GestionPaiement from "../gestion-paiement/gestion-paiement";
import ReservationDetailSommaireGrid from "./reservation-detail-sommaire-grid";
import {Item} from "devextreme-react/toolbar";
import GestionActivites from "../gestion-activites/gestion-activites";
import PopupPage, {useContextPopupPage} from "../../components/popups/PopupPage";
import ITrancheAge from "../../models/ITrancheAge";
import {ISelectedCells} from '../calendrier/calendrier-interfaces';
import useApi, {IApiErreur} from "../../hooks/useApi";
import PopupCourriel from '../../components/popups/popup-courriel';
import {useAuth} from "../../contexts/auth";
import {FieldDataChangedEvent} from "devextreme/ui/form";
import {TypeAuxiliaire} from "../../models/TypeAuxiliaire";
import ImpressionConfirmation from "./impression-confirmation";
import {PopupTypeMessage} from "./popup-type-message";
import IMessage from "../../models/IMessage";
import ListProduitsDisponible from "./list-produit-disponible";
import {Button} from "devextreme-react/button";
import {IonIcon} from "@ionic/react";
import {pricetag} from "ionicons/icons";
import {IItemOptions} from "../base/form-list-base-toolbar";
import PopupPromotion from "./popup-promotion";
import {IPromotionApplicableSel} from "../../models/IPromotionApplicable";
import IPromotionAppliquee from "../../models/IPromotionAppliquee";
import CarteCredit from "../../components/carte-credit/carte-credit";
import MessageBox from "../../components/popups/MessageBox";
import {Popup, Position, ToolbarItem} from "devextreme-react/popup";
import IPaiementProfile from "../../models/IPaiementProfile";


export interface IAjoutReservationOption {
    tranchesAges: ITrancheAge[],
    idTypeEquipement: Guid,
    longueurEquipement: number,
    unites: ISelectedCells[],
    nombreAnimaux?: number,
    idPlanAnimaux?: Guid
}

interface IGestionReservationProps {
    idReservationEntete?: Guid
    collapseListe?: boolean,
    isModeSelection?: boolean,
    ajoutReservationOption?: IAjoutReservationOption
    saveBtnRef?: any
}

const disabledOptions = {disabled: false};
export default function GestionReservations({
  idReservationEntete,
  collapseListe,
  isModeSelection,
  ajoutReservationOption,
  saveBtnRef
}: IGestionReservationProps) {
  const [newReservationOption, setNewReservationOption] = useState<IAjoutReservationOption | undefined>()
  const { postData: postPromotion } = useApi<IGestionReservation>("promotion");
  const { setSelectedValue, setDoitSauvegarder, onClose: onClosePopup } = useContextPopupPage();
  const reservationDataSourceOption: IFormBaseDataSourceOptions<IGestionReservation> = useMemo(() => ({
    path: "reservation",
    customReadByIdPath: "reservation/{key}/gestion",
    customSauvegarderPath: "reservation/save",
    primaryKey: "idReservationEntete",
    defaultId: idReservationEntete,
    newRow: newReservationOption !== undefined,
    onSauvegarder: () => {
      setNewReservationOption(undefined)
    }
  }), [idReservationEntete, newReservationOption])

    const reservationFormDataSource = useCustomDataSource<IReservationList, IGestionReservation>(reservationDataSourceOption);
    const {
        selectedDataRow: selectedReservation,
        setSelectedDataRow: setSelectedReservation,
        mode,
        onFieldDataChanged,
        setMainForm,
        dataSource,
        setIsFieldModifier,
        setMode,
        isFieldModifier,
        sauvegarder,
    } = reservationFormDataSource;
    const [isPopupVisibleDepot, setPopupVisibilityDepot] = useState(false);
    const [isPopupVisibleCourriel, setPopupVisibilityCourriel] = useState(false);
    const [isPopupVisibleConfirmationReservation, setIsPopupVisibleConfirmationReservation] = useState(false);
    const [isPopupVisibleMessageConfirmationReservation, setIsPopupVisibleMessageConfirmationReservation] = useState(false);
    const [isPopupVisiblePromotion, setIsPopupVisiblePromotion] = useState(false);
    const [idMessageImpressionConfirmation, setIdMessageImpressionConfirmation] = useState<Guid | undefined>()
    const [isMessageConfirmerAnnulationReservationOpen, setIsMessageConfirmerAnnulationReservationOpen] = useState(false);
    const [erreur, setErreur] = useState<IApiErreur>();

    const formRef = useRef<FormRef>(null);
    const {clientEditorOptions, currentClient, PopupGestionClient} = useClient(true, selectedReservation?.reservationEntete?.idClient);
    const {reservationCouleurGridCellItemRender, reservationCouleurEditorOptions} = useReservationCouleur()
    const {
        editorOptions: activiteEditorOptions,
        PopupGestion: PopupGestionActivite
    } = useLookUpBase({isModeModifier: mode !== Mode.Lecture, controllerName: "activite"});
    const {fetchData, postData} = useApi<IGestionReservation>("reservation");
    const {getData: getDefaultMessage} = useApi<IMessage>("message");
    const GuidFFF = new Guid("ffffffff-ffff-ffff-ffff-ffffffffffff");
    const {user} = useAuth();

    const dataGridRef = useRef<DataGridRef>(null);

    useEffect(() => {
        setNewReservationOption(ajoutReservationOption);
        if (ajoutReservationOption)
            setDoitSauvegarder && setDoitSauvegarder(true);
    }, []);

    const currentReservationCouleur = useMemo(() => reservationCouleurEditorOptions.dataSource?.find(f => {
        return f.idReservationCouleur.equals(selectedReservation?.reservationEntete?.idUsagerSuppression ? GuidFFF : selectedReservation?.reservationEntete?.idEtatReservation)
    }), [reservationCouleurEditorOptions.dataSource, selectedReservation?.reservationEntete?.idUsagerSuppression, selectedReservation?.reservationEntete?.idEtatReservation]);

    const montantDepotEditorOptions = useMemo(() => {
        return {format: "#0.00 $"}
    }, [])

    const togglePopupDepot = () => {
        setPopupVisibilityDepot(!isPopupVisibleDepot);
    };

    const togglePopupCourriel = async () => {
        const message = await getDefaultMessage({customPath: "message/getDefaultMessage/c", returnOnly: true});
        setIdMessageImpressionConfirmation(message.idMessage)
        setPopupVisibilityCourriel(!isPopupVisibleCourriel);
    };

    useEffect(() => {
        setMainForm(formRef.current?.instance());
    })

    useEffect(() => {
        if (dataSource) {
            dataSource.store().insert = async (values) => {
                setIsFieldModifier(true);
                setSelectedReservation(values)
            }
            dataSource.store().update = async (key, values) => {
                if (values) {
                    setSelectedReservation(values)
                    setIsFieldModifier(true);
                }
            }
        }
    }, [dataSource, selectedReservation]);

  const renderLabelNbrDays = useCallback(() => <div className={"dx-field-item-label-text"}>Nombre de jours avant
    ménage</div>, []);
  const onFocusedRowChanged = useCallback((e: any) => {
    if (isFieldModifier) {
      setIsFieldModifier(false)
    }

    if (setSelectedValue && e.row?.data) {
      setSelectedValue(e.row.data);
    }
  }, [setIsFieldModifier, isFieldModifier]);
  const colCLientEditorOptions = useMemo(() => ({ with: "fit-content" }), []);

    const onPopupDepotClose = (currentId: Guid | undefined) => {
        setPopupVisibilityDepot(false)
        if (currentId) {
            dataSource?.store().byKey(currentId);
        }
        dataSource?.reload()
    };

    useEffect(() => {
        //if (!newReservationOption || newReservationOption?.unites.length <= 0) return;
        const abortController = new AbortController();
        if (newReservationOption?.unites && newReservationOption?.unites.length > 0) {
            setMode(Mode.Ajout);
            fetchData("post", {
                customPath: `reservation/ajouter`,
                body: {...newReservationOption, idUsager: user?.idUsager},
                abortSignal: abortController.signal
            }).then((data) => {
                return setSelectedReservation({
                    ...data,
                    reservationEntete: {
                        ...data.reservationEntete,
                        idUsagerCreation: user?.idUsager,
                        idUsagerModification: user?.idUsager
                    }
                });
            });
        }
        return () => abortController.abort();
    }, [newReservationOption]);

    useEffect(() => {
        if (mode === Mode.Lecture || !reservationFormDataSource.selectedDataRow || !reservationFormDataSource.selectedDataRow?.reservationEntete?.idReservationEntete || !Guid.IsGuidTemporaire(reservationFormDataSource.selectedDataRow.reservationEntete.idReservationEntete) || !currentClient?.idClient || currentClient?.idClient.isEmpty()) return;

        reservationFormDataSource.setSelectedDataRow(prev => {
            return {
                ...prev, reservationDetailSommaires: [...prev.reservationDetailSommaires.map(detailSommaire => {
                    return {
                        ...detailSommaire,
                        idClient: currentClient?.idClient,
                        reservationDetails: [...detailSommaire.reservationDetails.map(detail => {
                            return {...detail, idClient: currentClient?.idClient}
                        })]
                    }
                })]
            } as IGestionReservation;
        })
        postData({
            ...reservationFormDataSource.selectedDataRow, reservationDetailSommaires: [...reservationFormDataSource.selectedDataRow.reservationDetailSommaires.map(detailSommaire => {
                return {
                    ...detailSommaire,
                    idClient: currentClient?.idClient,
                    reservationDetails: [...detailSommaire.reservationDetails.map(detail => {
                        return {...detail, idClient: currentClient?.idClient}
                    })]
                }
            })]
        } as IGestionReservation, "reservation/CalculerTotal", true)
            .then((reservation) => {
                setSelectedReservation(reservation)
            })

    }, [mode, currentClient, reservationFormDataSource.selectedDataRow?.idReservationEntete])

    const onFormFieldDataChanged = useCallback((e: FieldDataChangedEvent) => onFieldDataChanged(e), [onFieldDataChanged]);

    /*const ajouter = useCallback(() => {
        fetchData("get", {customPath: `reservation/default`}).then((data) => {
                setSelectedReservation({
                    ...data,
                    reservationEntete: {
                        ...data.reservationEntete,
                        idUsagerCreation: user?.idUsager,
                        idUsagerModification: user?.idUsager
                    }
                });
                setIsModeModify(true);
            }
        );
    }, [fetchData, setSelectedReservation, user?.idUsager, setIsModeModify]);*/

    const styleEtatReservation = useMemo(() => (
            {
                display: "flex",
                width: "150px",
                justifyContent: "center",
                marginRight: "0.1rem",
                padding: "0.5rem",
                height: "100%",
                backgroundColor: currentReservationCouleur?.couleurBackground,
                color: currentReservationCouleur?.couleurTexte,
                borderRadius: "0.2rem",
            })
        , [currentReservationCouleur?.couleurBackground, currentReservationCouleur?.couleurTexte]);

    const sauvegarderOptions = useMemo<IItemOptions>(() => {
        return {
            text: "Sauvegarder",
            click: (e: any) => {
                setIsPopupVisiblePromotion(true);
                e.preventDefault = true;
            },
        };
    }, []);

    const effacerOptions = useMemo<IItemOptions>(() => ({
        text: "Annuler réservation",
        icon: "remove",
        click: (e: any) => {
            setIsMessageConfirmerAnnulationReservationOpen(true)
            e.preventDefault = true;
        }
    }), [])

    const ajouterOptions = useMemo<IItemOptions>(() => ({
        text: "Ajouter",
        icon: "plus",
        click: (e: any) => {
            fetchData("get", {customPath: `reservation/default`}).then((data) => {
                setSelectedReservation({
                    ...data,
                    reservationEntete: {
                        ...data.reservationEntete,
                        idUsagerCreation: user?.idUsager,
                        idUsagerModification: user?.idUsager
                    }
                });
                setMode(Mode.Ajout);
            })
        }
    }), [fetchData, setSelectedReservation, user?.idUsager, setMode])

    const onConfirmeAnnulerReservation = useCallback(() => {
        fetchData("put", {
            body: {
                idReservationEntete: selectedReservation?.idReservationEntete,
                idUsagerAnnulation: user?.idUsager,
                annuler: true
            },
            customPath: "reservation/annulerReservation",
            returnOnly: true
        }).then(async (res) => {
            if ("errorMessage" in res) {
                setErreur(res);
            } else {
                await dataSource?.reload()
                dataSource?.store().byKey(selectedReservation.idReservationEntete)
            }
        })
        setIsMessageConfirmerAnnulationReservationOpen(false)
    }, [selectedReservation.idReservationEntete, fetchData, user?.idUsager, dataSource]);
    const messageBoxAnnulerReservationonAnnuler = useCallback(() => setIsMessageConfirmerAnnulationReservationOpen(false), []);

    const erreurPopupOkButtonOption = useMemo(() => {
        return {
            text: "Ok",
            onClick: () => {
                setErreur(undefined);
            }
        }
    }, [])

    useImperativeHandle(saveBtnRef, () => ({
        sauvegarder(e: any) {
            isFieldModifier && setIsPopupVisiblePromotion(true);
            (e || {}).preventDefault = true;
        }
    }))

    useEffect(() => {
        setDoitSauvegarder && setDoitSauvegarder(isFieldModifier);
    }, [isFieldModifier]);

    const onChangedCreditCard = useCallback((selectedValue: IPaiementProfile | undefined) => {
        if (mode !== Mode.Modifier || (selectedValue?.idPaiementProfile || Guid.empty).equals((selectedReservation?.reservationEntete?.idPaiementProfile || Guid.empty))) return;
        setSelectedReservation(prev => ({...prev, reservationEntete: {...prev.reservationEntete, idPaiementProfile: selectedValue?.idPaiementProfile || Guid.empty}}))
        setIsFieldModifier(true);
    }, [mode]);

    return (
        <>
            <FormListBase data={{
                ...reservationFormDataSource //ajouter: ajouter
            }} listeInitialState={collapseListe ? 'cacher' : 'ouvert'} formName={"gestion-reservation"}>
                <FormListBaseToolbar
                    headerText={`Reservation #${selectedReservation?.reservationEntete?.noConfirmation}`}
                    sauvegarderOptions={sauvegarderOptions} annulerOptions={disabledOptions}
                    effacerOptions={effacerOptions} ajouterOptions={ajouterOptions}>

                    <Item key={"toolbar-item-depot"} location={"before"} widget={"dxButton"} locateInMenu={"auto"}
                          options={{icon: 'money', text: "Dépôt", onClick: () => togglePopupDepot()}}/>
                    <Item key={"toolbar-item-courriel"} location={"before"} widget={"dxButton"} locateInMenu={"auto"}
                          options={{icon: 'email', text: "Courriel", onClick: () => togglePopupCourriel()}}/>
                    <Item key={"toolbar-item-imprime"} location={"before"} widget={"dxButton"} locateInMenu={"auto"}
                          options={{
                              icon: "print", text: "Imprimer", onClick: async () => {
                                  const message = await getDefaultMessage({customPath: "message/getDefaultMessage/c", returnOnly: true});
                                  setIdMessageImpressionConfirmation(message.idMessage)
                                  setIsPopupVisibleMessageConfirmationReservation(true)
                              }
                          }}/>
                    <Item location={"after"}>
                        <div style={styleEtatReservation}>{currentReservationCouleur?.descriptionFrancaise}</div>
                    </Item>
                </FormListBaseToolbar>
                <FormListBaseGrid ref={dataGridRef} dataSource={reservationFormDataSource.dataSource}
                                  onFocusedRowChanged={onFocusedRowChanged}
                                  focusedRowKey={idReservationEntete || selectedReservation.idReservationEntete}
                                  keyExpr={"idReservationEntete"}>
                    <Column dataType={"string"} key={"grid-col-no-confirmation"} cssClass={"grid-col-no-confirmation"}
                            dataField={"noConfirmation"} caption="No. Confirmation"/>
                    <Column key={"grid-col-client"} cssClass={"grid-col-client"}
                            dataField={"client"} caption="Client" editorOptions={colCLientEditorOptions}>
                    </Column>
                    <Column key={"grid-col-date-debut"} cssClass={"grid-col-date-debut"}
                            dataField={"dateDebut"} caption="Début"/>
                    <Column key={"grid-col-date-fin"} cssClass={"grid-col-date-fin"}
                            dataField={"dateFin"} caption="Fin"/>
                    <Column width={100} key={"grid-col-Etat"} cssClass={"grid-col-Etat"}
                            dataField={"idEtatReservation"} caption="État"
                            dataType={"object"}
                            cellRender={reservationCouleurGridCellItemRender}>
                    </Column>
                    <Column visible={false} dataField={"idReservationEntete"}/>
                </FormListBaseGrid>
                {!isModeSelection || isModeSelection && mode !== Mode.Lecture ?
                    <div className={"reservation-left-container"}>
                        <TabPanel scrollingEnabled={false} showNavButtons={true} width={"260px"} style={{height: "0px"}}>
                            <TabItem title={'Unités disponibles'}>
                                <ListUniteDisponible
                                    dateDebutReservation={selectedReservation?.dateArrivee || new Date()}
                                    dateFinReservation={selectedReservation?.dateDepart || new Date()}
                                    isModeModify={mode !== Mode.Lecture}/>
                            </TabItem>
                            <TabItem title={'Produits'}>
                                <ListProduitsDisponible isModeModify={mode !== Mode.Lecture} isReservation={true}/>
                            </TabItem>
                        </TabPanel>
                        <div className={"flex-1"}>
                            <TabPanel>
                                <TabItem title="Informations">
                                    <div className={"tabItemContent"}>
                                        <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabels={false}
                                              formData={selectedReservation} labelLocation={"left"}
                                              showColonAfterLabel={true} onFieldDataChanged={onFormFieldDataChanged}>
                                            <GroupItem colCount={3}>
                                                <GroupItem caption={"Client"} cssClass={"groupe-client"}>
                                                    <GroupItem colSpan={3}>
                                                        <SimpleItem cssClass='client-label-style'
                                                                    dataField={"reservationEntete.idClient"}
                                                                    editorType={"dxSelectBox"}
                                                                    editorOptions={clientEditorOptions}>
                                                            <Label text={"Client"}/>
                                                        </SimpleItem>

                                                        <SimpleItem cssClass='client-label-style'>
                                                            <Label text={"Téléphone"}/>
                                                            <div>{currentClient ? formatTelephone(currentClient?.telephone1 || '') : null}</div>
                                                        </SimpleItem>
                                                        <SimpleItem cssClass='client-label-style'>
                                                            <Label text={"courriel"}/>
                                                            <div>{currentClient?.email}</div>
                                                        </SimpleItem>
                                                        <GroupItem alignItemLabels={false}>
                                                            <SimpleItem>
                                                                <Label text={"Réservation dû"}/>
                                                                <div>
                                                                    <span>{`${selectedReservation?.dateArrivee && format(selectedReservation?.dateArrivee, "dd-MM-yyyy HH:mm")} `}</span>
                                                                    <span className="dx-field-item-label-text">au</span>
                                                                    <span>{` ${selectedReservation?.dateDepart && format(selectedReservation?.dateDepart, "dd-MM-yyyy HH:mm")}`}</span>
                                                                </div>
                                                            </SimpleItem>
                                                        </GroupItem>
                                                    </GroupItem>
                                                    <GroupItem colCount={2}>
                                                        <SimpleItem cssClass={"bypass-form-auto-width paddingTrancheAge"}
                                                                    component={(e) => {
                                                                        const idReservationEntete = selectedReservation?.reservationEntete?.idReservationEntete
                                                                        const trancheAges = selectedReservation?.reservationAges?.filter(f => f.idAuxiliaire.toString() === idReservationEntete?.toString() && f.isAdulte === true);
                                                                        return <GestionReservaitonTrancheAgePopup
                                                                            id={idReservationEntete} adulte={true}
                                                                            border={true} trancheAges={trancheAges}
                                                                            isModeModifier={mode !== Mode.Lecture}
                                                                            onTrancheAgeValueChanged={() => setIsFieldModifier(true)}/>
                                                                    }}>
                                                            <Label text={"Total adultes"}/>
                                                        </SimpleItem>
                                                        <SimpleItem cssClass={"bypass-form-auto-width paddingTrancheAge"}
                                                                    component={(e) => {
                                                                        const idReservationEntete = selectedReservation?.reservationEntete?.idReservationEntete
                                                                        const trancheAges = selectedReservation?.reservationAges?.filter(f => f.idAuxiliaire.toString() === idReservationEntete?.toString() && f.isAdulte === false);
                                                                        return <GestionReservaitonTrancheAgePopup
                                                                            id={idReservationEntete} adulte={false}
                                                                            border={true} trancheAges={trancheAges}
                                                                            isModeModifier={mode !== Mode.Lecture}
                                                                            onTrancheAgeValueChanged={() => setIsFieldModifier(true)}/>
                                                                    }}>
                                                            <Label text={"Total enfants"}/>
                                                        </SimpleItem>
                                                    </GroupItem>
                                                </GroupItem>
                                                <GroupItem caption={"Info Réservation"} colSpan={1}>
                                                    <GroupItem>
                                                        <GroupItem>
                                                            <SimpleItem dataField={"reservationEntete.reference"}
                                                                        cssClass={"bypass-form-auto-width"}>
                                                                <Label text={"Référence"}/>
                                                            </SimpleItem>
                                                            <SimpleItem dataField={"reservationEntete.idActivite"}
                                                                        editorType={"dxSelectBox"}
                                                                        editorOptions={activiteEditorOptions}
                                                                        cssClass='bypass-form-auto-width'>
                                                                <Label text={"Activités"}/>
                                                            </SimpleItem>
                                                            <SimpleItem dataField={"nbrDays"}
                                                                        cssClass={"bypass-form-auto-width"}>
                                                                <Label render={renderLabelNbrDays}/>
                                                            </SimpleItem>
                                                        </GroupItem>
                                                        <GroupItem>
                                                            <SimpleItem cssClass={"bypass-form-auto-width"}
                                                                        editorType={"dxCheckBox"}
                                                                        dataField={"reservationEntete.bloquerFacturation"}>
                                                                <Label
                                                                    text={"Bloquer la facturation pour les utilisateurs"}/>
                                                            </SimpleItem>
                                                            <GroupItem colCount={2}>
                                                                <SimpleItem cssClass={"bypass-form-auto-width"}
                                                                            editorType={"dxCheckBox"}
                                                                            dataField={"reservationEntete.sousmission"}>
                                                                    <Label text={"Soumission"}/>
                                                                </SimpleItem>
                                                                <SimpleItem cssClass={"bypass-form-auto-width"}
                                                                            editorType={"dxCheckBox"}
                                                                            dataField={"reservationEntete.isGroupe"}>
                                                                    <Label text={"Groupe"}/>
                                                                </SimpleItem>
                                                            </GroupItem>
                                                        </GroupItem>
                                                    </GroupItem>
                                                </GroupItem>
                                                <GroupItem>
                                                    <TabbedItem cssClass={"tab-panel-note"}>
                                                        <Tab title={"Notes"}>
                                                            <SimpleItem dataField={"noteReservation.note"}
                                                                        editorType={"dxTextArea"}>
                                                                <Label visible={false}/>
                                                            </SimpleItem>
                                                        </Tab>
                                                        <Tab title={"Ménages"}>
                                                            <SimpleItem dataField={"noteReservation.noteMenage"}
                                                                        editorType={"dxTextArea"}>
                                                                <Label visible={false}/>
                                                            </SimpleItem>
                                                        </Tab>
                                                    </TabbedItem>
                                                </GroupItem>
                                            </GroupItem>
                                            <GroupItem colCount={5}>
                                                <GroupItem caption={'Unités réservées'} colSpan={4}>
                                                    <ReservationDetailSommaireGrid key={"reservation-detail-sommaire-grid"}
                                                                                   reservationFormDataSource={reservationFormDataSource}/>
                                                </GroupItem>
                                                <GroupItem cssClass={"total-section"}>
                                                    <GroupItem caption={'Dépôt'}>
                                                        <GroupItem colCount={3}
                                                                   cssClass='unite-reservation-depot-label-style'>
                                                            <SimpleItem dataField={'Requis'}>
                                                                <CheckBox
                                                                    elementAttr={{class: 'check-box-style'}}
                                                                    defaultValue={false}/>
                                                            </SimpleItem>
                                                            <SimpleItem colSpan={2} dataField={"depotSuggere"}
                                                                        cssClass={"text-align-right"}
                                                                        editorType={"dxNumberBox"}
                                                                        editorOptions={montantDepotEditorOptions}>
                                                                <Label text={"Suggéré"}/>
                                                            </SimpleItem>
                                                        </GroupItem>
                                                        <GroupItem colCount={2}>
                                                            <GroupItem>
                                                                <SimpleItem
                                                                    dataField={"reservationEntete.montantDepotRequis"}
                                                                    cssClass={"text-align-right"} editorType={"dxNumberBox"}
                                                                    editorOptions={montantDepotEditorOptions}>
                                                                    <Label visible={false}/>
                                                                </SimpleItem>
                                                                <SimpleItem
                                                                    dataField={"reservationEntete.montantDepotRequis2"}
                                                                    cssClass={"text-align-right"} editorType={"dxNumberBox"}
                                                                    editorOptions={montantDepotEditorOptions}>
                                                                    <Label visible={false}/>
                                                                </SimpleItem>
                                                                <SimpleItem
                                                                    dataField={"reservationEntete.montantDepotRequis3"}
                                                                    cssClass={"text-align-right"} editorType={"dxNumberBox"}
                                                                    editorOptions={montantDepotEditorOptions}>
                                                                    <Label visible={false}/>
                                                                </SimpleItem>
                                                            </GroupItem>
                                                            <GroupItem cssClass={'wrapp-depot'}>
                                                                <SimpleItem dataField={"reservationEntete.dateDelai"}
                                                                            editorType={"dxDateBox"}>
                                                                    <Label visible={false}/>
                                                                </SimpleItem>
                                                                <SimpleItem dataField={"reservationEntete.dateDelai2"}
                                                                            editorType={"dxDateBox"}>
                                                                    <Label visible={false}/>
                                                                </SimpleItem>
                                                                <SimpleItem dataField={"reservationEntete.dateDelai3"}
                                                                            editorType={"dxDateBox"}>
                                                                    <Label visible={false}/>
                                                                </SimpleItem>
                                                            </GroupItem>
                                                        </GroupItem>
                                                    </GroupItem>
                                                    <GroupItem caption={"Carte de Crédit"}>
                                                        <SimpleItem>
                                                            <CarteCredit idClient={selectedReservation?.reservationEntete?.idClient || Guid.empty} idProfileSelected={selectedReservation?.reservationEntete?.idPaiementProfile || Guid.empty} isModeModifier={mode !== Mode.Lecture} onChanged={onChangedCreditCard} afficherOptionAjouterEffacer={true}/>
                                                        </SimpleItem>
                                                    </GroupItem>
                                                    <GroupItem caption={'Facturation'}>
                                                        <div className='item-facturation'
                                                             style={{borderBottom: "1px solid #e0e0e0"}}>
                                                            <strong>Sous total</strong>
                                                            <strong>{(selectedReservation?.sousTotal || 0.00).toFixed(2)} $</strong>
                                                        </div>
                                                        <div className='item-facturation'>
                                                            <div style={{display: "flex", gap: "0.5rem", alignItems: "center"}}>
                                                                <label>Promotion</label>
                                                                <Button>
                                                                    <IonIcon style={{color: "#dfab40", fontSize: "1rem"}} icon={pricetag}/>
                                                                </Button>
                                                            </div>
                                                            <span>{((selectedReservation?.montantPromotion || 0) * -1).toFixed(2)} $</span>
                                                        </div>
                                                        <div className='item-facturation'>
                                                            <label>Frais de services</label>
                                                            <span>{(selectedReservation?.fraisService || 0.00).toFixed(2)} $</span>
                                                        </div>
                                                        <div className='item-facturation'>
                                                            <label>Taxes d'hébergement</label>
                                                            <span>{(selectedReservation?.taxeHebergement || 0.00).toFixed(2)} $</span>
                                                        </div>
                                                        <div className='item-facturation'>
                                                            <label>TPS</label>
                                                            <span>{(selectedReservation?.tps || 0.00).toFixed(2)} $</span>
                                                        </div>
                                                        <div className='item-facturation'>
                                                            <label>TVQ</label>
                                                            <span>{(selectedReservation?.tvq || 0.00).toFixed(2)} $</span>
                                                        </div>
                                                        <div className='item-facturation'
                                                             style={{borderTop: "1px solid #e0e0e0"}}>
                                                            <strong>Grand total</strong>
                                                            <strong>{(selectedReservation?.total || 0.00).toFixed(2)} $</strong>
                                                        </div>
                                                        <div className='item-facturation'>
                                                            <label>Dépôt</label>
                                                            <span>{(selectedReservation?.montantPaye || 0.00).toFixed(2)} $</span>
                                                        </div>
                                                        <div className='item-facturation'
                                                             style={{borderTop: "1px solid #e0e0e0"}}>
                                                            <strong>Solde</strong>
                                                            <strong>{((selectedReservation?.total || 0) - (selectedReservation?.montantPaye || 0)).toFixed(2)} $</strong>
                                                        </div>
                                                    </GroupItem>
                                                </GroupItem>
                                            </GroupItem>
                                        </Form>
                                    </div>
                                </TabItem>
                                <TabItem title="Système"><FormSysteme
                                    formData={selectedReservation?.reservationEntete || {} as IReservationEntete}/></TabItem>
                            </TabPanel>
                        </div>
                    </div> : null
                }
            </FormListBase>

            <PopupPage<Guid>
                titre="Dépôt"
                isPopupOpen={isPopupVisibleDepot}
                onClose={(value) => onPopupDepotClose(value)}
                mode={"ajout"}
                height={"60%"}
                width={"60%"}
            >
                <GestionPaiement id={selectedReservation?.idReservationEntete}
                                 typeAuxiliaire={TypeAuxiliaire.Reservation}
                                 idClient={selectedReservation?.reservationEntete?.idClient}
                                 montantAuxiliaireTotal={(selectedReservation?.total || 0)}/>
            </PopupPage>

            {isPopupVisibleCourriel ?
                <PopupCourriel
                    togglePopup={togglePopupCourriel}
                    onSend={async (e) => {
                        e.idReservationEntete = selectedReservation.idReservationEntete;
                        await postData(e, "reservation/EnvoitCourrielConfirmation", true);
                        setPopupVisibilityCourriel(false);
                    }}
                    defaultIdMessageConfirmation={idMessageImpressionConfirmation}
                    to={currentClient?.email}
                    noAuxiliaire={selectedReservation?.reservationEntete?.noConfirmation}
                    fichiersJoint={[{isFromBackEnd: true, type: "confirmation", name: `Confirmation de réservation ${selectedReservation?.reservationEntete?.noConfirmation}.pdf`, id: Guid.empty, data: ""}]}/> : null}

            <PopupGestionClient isModeSelection={mode !== Mode.Lecture} onSelectionchanged={(selectedClient) => {
                setIsFieldModifier(true);
                setSelectedReservation((prev: any) => {
                    return {
                        ...prev,
                        reservationEntete: {...prev?.reservationEntete, idClient: selectedClient.idClient}
                    } as IGestionReservation
                })
            }}/>
            {isPopupVisibleConfirmationReservation ? <ImpressionConfirmation idMessage={idMessageImpressionConfirmation} idReservationEntete={selectedReservation.idReservationEntete} onClose={() => {
                setIsPopupVisibleConfirmationReservation(false)
                setIdMessageImpressionConfirmation(undefined);
            }}/> : null}
            {isPopupVisibleMessageConfirmationReservation ? <PopupTypeMessage typeMessage={"c"} idMessageConfirmation={idMessageImpressionConfirmation} onClose={() => setIsPopupVisibleMessageConfirmationReservation(false)} onConfirme={(idMessage: Guid) => {
                setIdMessageImpressionConfirmation(idMessage);
                setIsPopupVisibleMessageConfirmationReservation(false);
                setIsPopupVisibleConfirmationReservation(true);
            }}/> : null}
            {isPopupVisiblePromotion ? <PopupPromotion reservation={selectedReservation} onClose={async (promotionApplicable: IPromotionApplicableSel[]) => {
                setIsPopupVisiblePromotion(false)

                selectedReservation.promotionAppliquees = [
                    ...selectedReservation.promotionAppliquees.map(m => ({...m, dateSuppression: promotionApplicable.some(s => s.idPromotion?.equals(m.idPromotion) && !s.selectionne) ? new Date() : m.dateSuppression})),
                    ...promotionApplicable.filter(f => f.selectionne && !selectedReservation.promotionAppliquees.some(s => s.idPromotion.equals(f.idPromotion))).map(promo => (
                        {
                            idPromotion: promo.idPromotion,
                            idAuxiliaire: selectedReservation.idReservationEntete,
                            rabais: promo.montantApplicable
                        } as IPromotionAppliquee))];

                if (sauvegarder) {
                    await sauvegarder();
                }
                setDoitSauvegarder && setDoitSauvegarder(false);
                onClosePopup && onClosePopup();
            }}/> : null}
            <PopupGestionActivite>
                <GestionActivites/>
            </PopupGestionActivite>
            <MessageBox title={"Annulation de réservation"} message={`Êtes-vous sûr de vouloir annuler la réservation ${selectedReservation?.reservationEntete?.noConfirmation}`} buttonType={"OuiNon"} onConfirme={onConfirmeAnnulerReservation} onAnnuler={messageBoxAnnulerReservationonAnnuler} isOpen={isMessageConfirmerAnnulationReservationOpen}/>
            <Popup visible={erreur != undefined} width={"500px"} height={"auto"} title={"Erreur"}>
                <Position
                    my="center"
                    collision="fit"
                />
                <div dangerouslySetInnerHTML={{__html: erreur?.errorMessage.replace("\r\n", "<br>") || ""}}/>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="center"
                    options={erreurPopupOkButtonOption}
                />
            </Popup>
        </>
    );
}
